<template>
  <div
    class="container-list-block"
    :class="[individualBackgroundBoxes ? 'backgroundBox' : '']"
  >
    <component
      :is="type"
      class="container-list-block__list"
    >
      <li
        v-for="(item) in listBlocks"
        :key="item.title"
      >
        <component
          :is="item.component === 'RecipeBlock' ? 'article-recipe-block' : item.component | kebab"
          :recipe="item.recipe"
          :title="item.title"
          :content="item.content"
          :image="item.image"
          :button-label="item.buttonLabel"
          :class="[individualBackgroundBoxes ? themeColor : '']"
          :url="item.url"
          :in-list="true"
        />
      </li>
    </component>
  </div>
</template>

<script>
export default {
  name: "ContainerListBlock",
  props: {
    listType: {
      type: String,
      default: 'Unordered'
    },
    individualBackgroundBoxes: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: 'default'
    },
    listBlocks: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: null
    },
  },
  data () {
    return {
      type: this.listType == 'Ordered' ? 'ol' : 'ul',
    }
  },
  computed: {
    themeColor () {
      return `theme__color--${this.theme}`
    }
  }
}
</script>

<style lang="scss">
.container-list-block {
  &__list {
    margin: 0;
    padding: 0;
    list-style: none;

    > li:first-child > * {
      margin-top: 0;
    }
  }

  &.backgroundBox li > div {
    padding: 1rem;
    margin-top: 1rem;
  }
}
</style>
